<div class="overlay">
  <div class="modal">
    <div class="modal-header">
      <h2>Configuração de Campanha</h2>
      <button class="close-modal" (click)="handleCloseModal()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-tabs">
      <button class="tab-button" [ngClass]="{'active': stepForm === 1, 'disabled-div': stepForm != 1}"
        data-tab="tab-1">Configuração</button>
      <button class="tab-button" [ngClass]="{'active': stepForm === 2, 'disabled-div': stepForm != 2}"
        data-tab="tab-2">Mensagem</button>
      <button class="tab-button" [ngClass]="{'active': stepForm === 3, 'disabled-div': stepForm != 3}"
        data-tab="tab-3">Customização</button>
      <button class="tab-button" [ngClass]="{'active': stepForm === 4, 'disabled-div': stepForm != 4}"
        data-tab="tab-4">Agendamentos</button>
    </div>
    <div class="modal-content">
      <div class="tab tab-1" [ngClass]="{'active': stepForm === 1}">
        <form class="form" [formGroup]="formQueueWAMD">
          <div class="form-group">
            <label for="campaignName">Nome da campanha: *</label>
            <input type="text" id="campaignName" placeholder="Nome da campanha" formControlName="nome">
            <small style="color: red"
              *ngIf="formQueueWAMD.get('nome')?.errors?.['required'] && formQueueWAMD.get('nome')?.touched"> E
              obrigatorio inserir um nome</small>
          </div>
          <div class="form-group">
            <label for="selectList">Selecionar lista: *</label>
            <select id="selectList" formControlName="idLista">
              <option *ngFor="let lista of listContacts" [value]="lista.idlist">{{lista.nome}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="selectCountry">Selecione o País: *</label>
            <select id="selectCountry">
              <option *ngFor="let country of countrys">{{country.name}}</option>
            </select>

          </div>
          <div class="div-ext-data">
            <label for="adicionarCampoEXT" class="line-agendamento">
              <input type="checkbox" id="adicionarCampoEXT" (change)="handleAddExt($event)" />
              Adicionar campo EXT</label>
            <ng-container *ngIf="addExt">
              <input class="input-ext" type="text" placeholder="Digite o valor de referencia" formControlName="extData" />
            </ng-container>
          </div>

          <div class="form-group">
            <label class="label-add-midias">Adicionar Midias: <button class="button-remove" *ngIf="quantidadeMidias > 0"
                (click)="handleRemoveInputMidias()"><mat-icon>remove</mat-icon></button><button class="button-add"
                (click)="handleAddInputMidias()"><mat-icon>add</mat-icon></button></label>
            <input type="file" *ngIf="quantidadeMidias > 0" class="input-file" (change)="handleInsertFile($event)"
              accept=".pdf,.jpeg,.jpg,.png,.ogg,.mp4" />
            <input type="file" *ngIf="quantidadeMidias > 1" (change)="handleInsertFile($event)"
              accept=".pdf,.jpeg,.jpg,.png,.ogg,.mp4">
            <input type="file" *ngIf="quantidadeMidias > 2" (change)="handleInsertFile($event)"
              accept=".pdf,.jpeg,.jpg,.png,.ogg,.mp4">
          </div>
          <div class="modal-footer">
            <button class="prev-tab" (click)="handleCloseModal()">Cancelar</button>
            <button class="next-tab" (click)="handleNextStep()" [disabled]="!handleValidStepOne()"
              [ngClass]="{'inactive-button': !handleValidStepOne()}">Continuar</button>
          </div>
        </form>
      </div>
      <div class="tab tab-2" [ngClass]="{'active': stepForm === 2}">
        <form [formGroup]="formQueueWAMD">
          <div class="form-group">
            <label for="messageTemplate">Mensagem cadastrada:</label>
            <select id="messageTemplate" (change)="handleSelectMessagePredefined($event)">
              <option selected disabled value="">Selecione uma mensagem</option>
              <option *ngFor="let message of listMessagesPredefined" [value]="message.message">{{message.title}}
              </option>
            </select>
            <button class="next-tab" (click)="handleAddRefName()">Referenciar Nome</button>
          </div>
          <div class="form-group">
            <label for="messageContent">Mensagem: *</label>
            <div class="textarea-container">
              <textarea class="mensagem-textarea" placeholder="Mensagem" formControlName="mensagem"></textarea>
              <button class="emoji-button" (click)="toggleEmojiPicker($event)">😊</button>
            </div>
            <emoji-mart *ngIf="isEmojiPickerVisible" (emojiClick)="addEmoji($event)"></emoji-mart>
          </div>
          <div class="modal-footer">
            <button class="prev-tab" (click)="handlePreviousStep()">Voltar</button>
            <button class="next-tab" (click)="handleNextStep()" [disabled]="!handleValidStepTwo()"
              [ngClass]="{'inactive-button': !handleValidStepTwo()}">Continuar</button>
          </div>
        </form>
      </div>
      <div class="tab tab-3" [ngClass]="{'active': stepForm === 3}">
        <form [formGroup]="formQueueWAMD">
          <div class="form-group">
            <label for="sendOrder">Ordem de envio: *</label>
            <select id="sendOrder" formControlName="ordemenvio">
              <option value="0">Texto/Midia</option>
              <option value="1">Midia/Texto</option>
            </select>
          </div>
          <div class="form-group-channels">
            <div class="channels-container">
              <label for="channels">Canais que deseja disparar: *</label>
              <div class="channel" *ngFor="let canal of listChannels">
                <input type="checkbox" [value]="canal.idcanal" class="checkbox"
                  [disabled]="canal.status === 'Desconectado'" (change)="handleSelectChannel($event)">
                <label for="channel-1" class="channel-label">
                  <span class="channel-name">{{canal.nomefila}}</span>
                  <span class="status"
                    [ngClass]="{'connected': canal.status === 'Conectado', 'disconnected' : canal.status === 'Desconectado'}">{{canal.status}}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="prev-tab" (click)="handlePreviousStep()">Voltar</button>
            <button class="next-tab" (click)="handleNextStep()"
              [ngClass]="{'inactive-button' : !handleValidStepThree()}"
              [disabled]="!handleValidStepThree()">Continuar</button>
          </div>
        </form>
      </div>
      <div class="tab tab-4" [ngClass]="{'active': stepForm === 4}">
        <form [formGroup]="formQueueWAMD">
          <div>
            <label>Envio personalizado: *</label>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" (change)="handleIsScheduled($event)" />
                  Agendar Envio
                </label>
                <input *ngIf="isScheduled" class="input-time" type="time" (change)="handleManualyTimeData($event)" />
                <input *ngIf="isScheduled" type="date" placeholder="DD/MM/YYYY" [ngModel]="formattedDate"
                  class="input-date" (change)="handleManualyDateData($event)" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" formControlName="hComercial" />
                  Disparar somente em horario comercial (08:00 as 19:00)

                </label>
              </div>
            </div>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" formControlName="antiSpam" />
                  Sistema Anti-Spam (Codigo Final da Mensagem)
                </label>
              </div>
            </div>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" formControlName="sunday" />
                  Disparar aos Domingos
                </label>
              </div>
            </div>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" formControlName="saturday" />
                  Disparar aos Sabados
                </label>
              </div>
            </div>
            <div class="form-disparo-row">
              <div class="line-agendamento">
                <label class="line-agendamento">
                  <input type="checkbox" id="" (change)="handleAcceptTerm($event)" />
                  Concordo com os Termos do <a
                    href="https://www.whatsapp.com/legal/terms-of-service?lang=pt_BR" target="_blank">Whatsapp
                    <strong style="color: red;">*</strong></a>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="prev-tab" (click)="handlePreviousStep()">Voltar</button>
            <button class="next-tab" (click)="handleSendFire()" [disabled]="!handleValidStepFour()" [ngClass]="{'inactive-button': !acceptTerm}">Enviar</button>
          </div>
        </form>
      </div>
    </div>
    <!-- <div class="modal-footer">
      <button class="prev-tab">Voltar</button>
      <button class="next-tab">Continuar</button>
    </div> -->
  </div>
</div>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>